/**
 * Named signage dashboards — types from `@navio/nsdk`.
 */

import type {
  DashboardCreateApiData,
  DashboardCreateApiResponses,
  DashboardDeleteApiData,
  DashboardDeleteApiResponses,
  DashboardGetApiData,
  DashboardGetApiResponses,
  DashboardItemsReplaceApiData,
  DashboardItemsReplaceApiResponses,
  DashboardListApiData,
  DashboardListApiResponses,
  DashboardPatchApiData,
  DashboardPatchApiResponses
} from '@navio/nsdk';

import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';

export const getSignageDashboardUrls = {
  getSignageDashboards: dataEndpoint<DashboardListApiData, DashboardListApiResponses>({
    getUrl: (queryParams) => apiUrl('dashboard/dashboards/', queryParams)
  }),
  getSignageDashboard: dataEndpoint<DashboardGetApiData, DashboardGetApiResponses>({
    getUrl: ({ dashboardId }) => apiUrl(`dashboard/dashboards/${dashboardId}/`)
  }),
  postSignageDashboard: responseEndpoint<DashboardCreateApiData, DashboardCreateApiResponses>({
    getUrl: () => apiUrl('dashboard/dashboards/'),
    getBody: (data) => data
  }),
  patchSignageDashboard: responseEndpoint<DashboardPatchApiData, DashboardPatchApiResponses>({
    getUrl: ({ dashboardId }) => apiUrl(`dashboard/dashboards/${dashboardId}/`),
    getBody: ({ dashboardId: _dashboardId, ...body }) => body
  }),
  deleteSignageDashboard: dataEndpoint<DashboardDeleteApiData, DashboardDeleteApiResponses>({
    getUrl: ({ dashboardId }) => apiUrl(`dashboard/dashboards/${dashboardId}/`)
  }),
  postSignageDashboardItems: responseEndpoint<DashboardItemsReplaceApiData, DashboardItemsReplaceApiResponses>({
    getUrl: ({ dashboardId }) => apiUrl(`dashboard/dashboards/${dashboardId}/items/`),
    getBody: ({ dashboardId: _dashboardId, ...body }) => body
  })
};
